import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../redux/slices/authSlice";
import { refreshRequests } from "../redux/slices/cachedRequestsSlice";
import { setLoaderState } from "../redux/slices/loaderSlice";
import { console_log } from "../utils/console_log";
import { PostService } from "./services/requests-service";

const usePostData = () => {
  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState(null);
  const [errors, setErrors] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ====handle Logout====
  // ====handle Logout====
  const handleLogout = (error) => {
    dispatch(logout());
    dispatch(refreshRequests(true));
    navigate("/sign-in");
    setErrors(error?.response?.data?.msg);
  };

  const postData = async ({
    route,
    data,
    params,
    onUploadProgress = () => {},
    disableLogout = false,
    customError=false,
  }) => {
    try {
      setLoading(true);
      dispatch(setLoaderState(true));
      const res = await PostService({ route, data, params, onUploadProgress });
      setLoading(false);
      dispatch(setLoaderState(false));
      setErrors(null);
      setResData(res);
      return res;
    } catch (error) {
      //    handle error msg ()
      console_log({ error });
      setErrors(error);
      setLoading(false);
      dispatch(setLoaderState(false));

      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        if(!disableLogout){
          handleLogout(error);
        }
      } else {
        setErrors({ error: error?.response?.data?.msg });
      }
      return { error: !customError ? error.response.data.error : error?.response?.data?.msg };
    }
  };

  return {
    loading,
    res: resData,
    errors,
    postData,
    setres: setResData,
  };
};

export default usePostData;
